var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',[(_vm.isSidebarNeeded)?_c('TheSidebar'):_vm._e(),(_vm.isHeaderNeeded)?_c('TheHeader'):_vm._e(),_c('v-main',[_c('v-container',{class:_vm.containerClass,attrs:{"fluid":_vm.enableFluid}},[_c('router-view')],1)],1),_c('TheSnackbar'),_c('TheConfirmationDialog')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }